/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-05-17T10:46:25.412
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveEvaluateAppointmentKeeprecord,
	getEvaluateAppointmentKeeprecordCreateInit,
	getEvaluateAppointmentKeeprecordEditInit,
	getEvaluateAppointmentKeeprecordView,
	deleteEvaluateAppointmentKeeprecord
} from '@api/storagemanage/EvaluateAppointmentKeeprecord';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getEvaluateAppointmentKeeprecordCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getEvaluateAppointmentKeeprecordCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getEvaluateAppointmentKeeprecordEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getEvaluateAppointmentKeeprecordEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveEvaluateAppointmentKeeprecord({}, EvaluateAppointmentKeeprecord) {
			return new Promise((resolve, reject) => {
				saveEvaluateAppointmentKeeprecord(EvaluateAppointmentKeeprecord)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getEvaluateAppointmentKeeprecordView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getEvaluateAppointmentKeeprecordView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteEvaluateAppointmentKeeprecord({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteEvaluateAppointmentKeeprecord({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
